import { useEffect, useRef, useState } from "react";
import { vocabularize } from "src/Common/vocab";

import _ from "lodash";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  API_URL,
  can,
  downloadFile,
  downloadImage,
  handleError,
  isAccountant,
  isManagerOver,
  isClericalOver,
} from "src/Common/function";
import Button from "src/Components/Button";
import CreateButton from "src/Components/CreateButton";
import DownloadButton from "src/Components/DownloadButton";
import UserService from "src/Services/API/user.service";
import WOService from "src/Services/API/wo.service";
import CreateWoModal from "./Components/createwomodal";
import WOFitlerView from "src/Components/filter/WOFilterView";
import BranchBar from "src/Components/branchbar/BranchBar";
import moment from "moment-timezone";
import { convertToArizonaTime } from "src/Common/common";
import TechnicianService from "src/Services/API/technician.service";
import WoTable, { WO_SCROLL_STORAGE_KEY } from "./Components/WoTable";
import useWoCustomerActivity from "src/hooks/useWoCustomerActivity";
import useChatUnread from "src/hooks/useChatUnread";

// The Jobs page's tabs, as the tech app's Jobs tab: Assigned (still open)
// and Past (Completed and on).
const JOB_TABS = [
  { key: "assigned", label: "Assigned", statusGroup: "open" },
  { key: "past", label: "Past", statusGroup: "closed" },
];

// jobs: the side menu's Jobs page (/jobs): the same list, only the work orders
// the user is assigned to, in Assigned / Past tabs.
function WO({ jobs = false }) {
  const currentUser = UserService.getCurrentUser();
  // const keyword = useSelector((state) => state.Keyword.keyword);
  const user = UserService.getCurrentUser();
  const [isCreateOpen, setIsCreateOpen] = useState(false);
  const [orderArray, setOrderArray] = useState([]);
  const [loadMoreButtonShown, setLoadMoreButtonShown] = useState(false);
  const [filterOpen, setFilterOpen] = useState(false);
  const [sort, setSort] = useState(null);
  // True while a scroll restore is fetching the previously loaded rows.
  const [restoring, setRestoring] = useState(false);

  const [isDownloading, setIsDownloading] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const criteria = searchParams.get("criteria");
  const [branch, setBranch] = useState(() => {
    const param = searchParams.get("branch");
    return param === null ? -1 : Number(param);
  });

  const keyword = searchParams.get("keyword") || "";

  // The side menu's Requests view (?requests=1): only work orders a customer
  // requested, pending or approved since. Rides along with any filter criteria.
  const requestsOnly = searchParams.get("requests") === "1";
  // Jobs: ?show=past for the Past tab, Assigned otherwise.
  const jobTab = JOB_TABS.find((tab) => tab.key === searchParams.get("show")) ?? JOB_TABS[0];
  const listCriteria = () => {
    const parsed = JSON.parse(criteria);
    if (jobs) return { ...(parsed ?? {}), mine: true, statusGroup: jobTab.statusGroup };
    return requestsOnly ? { ...(parsed ?? {}), requested: true } : parsed;
  };
  // Unread customer messages per Jobs tab. A technician's counts only cover
  // their own jobs; other people's cover their branches, so only technicians
  // get the tab counts.
  const chatUnread = useChatUnread();
  const technicianOnly = (() => {
    const roles = user?.roles ?? [];
    return roles.length > 0 && roles.every((role) => role.name === "Technician");
  })();
  const jobTabUnread = (tab) => {
    if (!technicianOnly) return 0;
    let count = 0;
    for (const [woId, n] of Object.entries(chatUnread.wos ?? {})) {
      const status = chatUnread.info?.[woId]?.status;
      const past = status >= 5;
      if ((tab.key === "past") === past) count += n;
    }
    return count;
  };

  // Pending scroll restoration coming back from the WO detail page.
  // Holds the saved WO id while pages are auto-loaded until it appears.
  const restoreRef = useRef(null);
  // Bumped on every fresh fetch cycle; responses from an older cycle (e.g.
  // the double fetch caused by branch initialization) are dropped so they
  // cannot overwrite the list or cancel a pending restore.
  const fetchGenRef = useRef(0);

  useEffect(() => {
    const param = searchParams.get("branch");
    setBranch(param === null ? -1 : Number(param));
  }, [searchParams]);

  useEffect(() => {
    fetchGenRef.current += 1;
    const gen = fetchGenRef.current;
    const saved = sessionStorage.getItem(WO_SCROLL_STORAGE_KEY);
    let pending = null;
    try {
      pending = saved ? JSON.parse(saved) : null;
      if (pending && pending.search !== undefined && pending.search !== location.search) {
        // Saved from a different filter/branch context — not restorable here.
        sessionStorage.removeItem(WO_SCROLL_STORAGE_KEY);
        pending = null;
      }
    } catch {
      pending = null;
      sessionStorage.removeItem(WO_SCROLL_STORAGE_KEY);
    }
    restoreRef.current = pending;
    setRestoring(!!pending);
    // A pending restore fetches every previously loaded row in one request.
    const limit = pending?.loadedCount > 0 ? pending.loadedCount : undefined;
    getAllWorkOrder([], { limit }, gen);
    if (criteria) {
      setFilterOpen(true);
    } else {
      setFilterOpen(false);
    }
    console.log("🚀 ~ WO ~ branch:", branch);
  }, [keyword, criteria, sort, branch, requestsOnly, jobs, jobTab.key]);

  // A customer request or proposal response arrives: reload the rows already
  // shown (same count, so the scroll position and Load More stay put).
  const orderCountRef = useRef(0);
  orderCountRef.current = orderArray.length;
  useWoCustomerActivity(() => {
    getAllWorkOrder([], { limit: orderCountRef.current || undefined });
  });

  const getAllWorkOrder = (previousOrderArray, { limit } = {}, gen = fetchGenRef.current) => {
    // Offset-based continuation: rows deleted from the list can't shift page
    // boundaries the way pageNumber-based pagination could.
    const offset = previousOrderArray.length;
    WOService.getAllWorkOrders(user.id, keyword, 0, listCriteria(), sort, branch, limit, offset)
      .then((response) => {
        if (gen !== fetchGenRef.current) return;
        if (response.status == 200) {
          let temp = [...previousOrderArray, ...response.data.orders];
          console.log("11111111111L: ", temp);
          setOrderArray(temp);
          setLoadMoreButtonShown(temp.length < response.data.totalCount);

          // Scroll restore is single-shot now: the id is either in this
          // response or the saved entry is stale. WoTable does the scroll.
          if (restoreRef.current) {
            const found = temp.some((order) => order.id === restoreRef.current.id);
            restoreRef.current = null;
            if (!found) {
              sessionStorage.removeItem(WO_SCROLL_STORAGE_KEY);
            }
            setRestoring(false);
          }
        }
      })
      .catch((error) => {
        setRestoring(false);
        handleError(error);
      });
  };

  // Returns the request promise so the modal can keep its submit button
  // disabled until the create settles (double-submit guard).
  const saveWO = (data, primaryTech) => {
    return WOService.createWorkOrder(data)
      .then(async (response) => {
        if (response.status === 201) {
          if (primaryTech) {
            try {
              const res = await TechnicianService.createTechnician({
                woId: response.data.id,
                data: [{ user: primaryTech.id, roleId: 0 }],
                eventUser: currentUser,
              });
            } catch (error) {
              handleError(error);
            }
          }
          setIsCreateOpen(false);
          toast(vocabularize("Work order created successfully"));
          getAllWorkOrder([]);
        } else {
          toast("something went wrong!");
        }
      })
      .catch((error) => {
        handleError(error);
      });
  };

  const handleLoadMore = () => {
    getAllWorkOrder(orderArray);
  };

  const downloadExcelFile = async () => {
    setIsDownloading(true);
    try {
      await WOService.generateExcelFile(user.id, keyword, listCriteria(), sort, branch);
      await downloadFile(`${API_URL}/files/${user.company}/reports/${user.id}/WOs_report.xlsx`, "WOs_report.xlsx");
      setIsDownloading(false);
    } catch (error) {
      handleError(error);
    }
  };

  const appendBranchParam = (query, value) => {
    const currentPath = location.pathname;
    const currentSearch = location.search;

    const url = new URLSearchParams(currentSearch);
    url.set(query, value); // replaces or adds branch=0

    navigate(`${currentPath}?${url.toString()}`);
  };

  return (
    <div className="w-full h-full flex flex-col bg-backgroundColor">
      <CreateWoModal
        order={null}
        onSubmitClicked={saveWO}
        shown={isCreateOpen}
        onCancelClicked={() => setIsCreateOpen(false)}
      />
      <div className="px-5 py-2 border-b border-borderColor">
        <BranchBar />
        {/* {(isManagerOver() || isAccountant()) && 
        } */}
      </div>
      {jobs && (
        <div role="tablist" className="flex items-center gap-2 px-5 pt-5">
          {JOB_TABS.map((tab) => {
            const active = tab.key === jobTab.key;
            const count = jobTabUnread(tab);
            return (
              <button
                key={tab.key}
                type="button"
                role="tab"
                aria-selected={active}
                onClick={() => appendBranchParam("show", tab.key)}
                className={`relative min-w-[120px] h-9 px-4 rounded-lg border font-OpenSansSemiBold text-[14px] cursor-pointer ${
                  active
                    ? "border-[#0065FD] bg-[#0065FD] text-white"
                    : "border-[#CBD5E1] bg-[#F1F5F9] text-[#45556C] hover:bg-[#E2E8F0]"
                }`}
              >
                {tab.label}
                {count > 0 && (
                  <span className="absolute -top-2 -right-2 min-w-[20px] h-[20px] px-[6px] rounded-full bg-red-500 text-white text-[11px] leading-[20px] font-OpenSansBold text-center">
                    {count > 99 ? "99+" : count}
                  </span>
                )}
              </button>
            );
          })}
        </div>
      )}
      {branch !== 0 && (
        <div className="w-full flex items-center gap-8 justify-end py-[20px] px-[18px]">
          {/* Filter button */}
          <Button onClicked={() => setFilterOpen(!filterOpen)} title="Filter" isHighlighted={filterOpen} />
          {/* Download button */}
          {filterOpen && <DownloadButton isLoading={isDownloading} onClicked={downloadExcelFile} />}
          {/* Create  button */}
          {!jobs && can("wo:create") && <CreateButton onClicked={() => setIsCreateOpen(true)} title="Create" testId="wo-create" />}
        </div>
      )}
      <div className="px-5 flex-1 min-h-0 flex flex-col py-5">
        {filterOpen && branch !== 0 && (
          <WOFitlerView
            apply={(data) => {
              appendBranchParam("criteria", JSON.stringify(data));
            }}
            clear={() => localStorage.removeItem("WO_CRITERIA")}
          />
        )}
        <WoTable
          data={orderArray}
          keyword={keyword}
          branch={branch}
          loadMore={handleLoadMore}
          loadMoreButtonShown={loadMoreButtonShown}
          restoring={restoring}
          deleteSuccess={(index) => {
            let temp = _.cloneDeep(orderArray);
            temp.splice(index, 1);
            setOrderArray(temp);
          }}
          sort={(data) => setSort(data)}
        />
      </div>
    </div>
  );
}

export default WO;
